export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11151.0f5bd3db.jpg";